import ArtistIcon from '@/assets/all-icons/artist-icon';
import Text from '@/shared-components/text/components/Text';

import './styles/AuthSignupSelector.css';

export default function AuthSignupSelector({ setCurrentPage }) {
  return (
    <>
      <div className="auth-signup-selector__container" onClick={()=>setCurrentPage("artist-signup")}>
        <div className="auth-signup-selector__icon-box">
          <ArtistIcon className="auth-sign-up-selector__icon artist"/>
        </div>

        <Text className="auth-signup-selector__text" medium>
                    As an artist
        </Text>
      </div>
    </>
  );
}
